import React from 'react';

import { Grid, Divider, Image, Button } from 'semantic-ui-react'

import { Hero, Action, Player, ActionType, Team, TierConverter, DraftType } from './types'

import HeroImage from './heroes/heroImage'

import UnpickedIcon from './heroes/meleeHeroesImages/unpicked_icon.png';

import { getHeroImage } from './heroes/useHeroes'

import { getDoppelgangerTargetName } from './utils/cardEvents'

import { useMeleeContext } from './context/MeleeContextProvider';
import { GetRandomHeroForPlayer } from './utils/drafter';
import { PlayerNumberToColor } from './utils/colorUtils';


export interface PlayerDraftCardProps {
    player: Player,
    currentAction?: Action,
    executeAction?: () => void,
    applyHeroAction?: (player: Player, hero: Hero, action: ActionType) => void,
    addPlayerToSelection?: (player: Player) => void
}

export default function PlayerDraftCard(props: PlayerDraftCardProps) {
    const meleeContext = useMeleeContext();

    function renderHeroes(): any {
        return (
            props.player.Draft!.map((hero, index) => (
                <Grid.Column key={"hero-draft-" + index} >
                    <HeroImage
                        Hero={hero}
                        cardProps={props}
                        Banned={hero ? props.player.BannedHeroes!.includes(hero.Name) : false}
                    />
                </Grid.Column>
            ))
        )
    }

    const isPlayersTurn = (): boolean => {
        if (props.currentAction) return props.currentAction.Team === props.player!.Team
        return false;
    }

    const showSelectButton = (): boolean => {
        if (!props.currentAction) return false;

        // Can pick player with pciked heroes if doppelganger
        if (props.currentAction.Action === ActionType.SelectEnemey &&
            teamHasDoppelganger(props.currentAction.Team) &&
            props.currentAction.Team !== props.player.Team)
            return true

        if (props.player.PickedHero)
            return false;

        if (props.currentAction.Action === ActionType.SelectFriendly && isPlayersTurn()) {
            return true;
        }
        if (props.currentAction.Action === ActionType.SelectEnemey && !isPlayersTurn()) {
            return true;
        }

        return false;
    }

    const teamHasDoppelganger = (team: Team): boolean => {
        const temp = meleeContext?.players.find(p =>
            p.PickedHero?.Name.includes("Doppelganger") && p.Team === team
        );
        return temp ? true : false;
    }

    const selectThisPlayer = (): void => {
        if (props.addPlayerToSelection && props.player && props.executeAction) {
            props.addPlayerToSelection(props.player);
            props.executeAction();
        }
    }

    const randomHeroClick = (): void => {
        if (props.addPlayerToSelection && props.player && props.executeAction && meleeContext!.gameData) {
            props.addPlayerToSelection(props.player);
            props.player.PickedHero = GetRandomHeroForPlayer(meleeContext!.gameData.GameType, props.player);
            props.executeAction();
        }
    }

    const allHeroesBanned = (): boolean => {
        if (!props.player || props.player.PickedHero || !props.currentAction) return false;
        if (props.currentAction.Action !== ActionType.Pick || !isPlayersTurn()) return false;

        let allHeroesBanned = true;

        const draftAsStringArray: string[] = [];
        props.player.Draft!.forEach(hero => draftAsStringArray.push(hero.Name));

        draftAsStringArray.forEach(hero => {
            if (!props.player) return;
            if (!props.player.BannedHeroes!.includes(hero)) {
                allHeroesBanned = false;
            }
        })
        return allHeroesBanned
    }

    const renderTierSection = () => {
        if (!props.player!.PickedHero) return <></>

        let content = ""
        const tier = props.player!.PickedHero!.Tier
        if (tier && props.player!.PickedHero) {
            //Renders doppelganger name
            if (tier === -1) {
                content = getDoppelgangerTargetName(meleeContext!.gameData);
            } else {
                content = TierConverter(tier);
            }
            return (<h5 className={`tier-${props.player!.PickedHero.Tier}`} style={{ margin: 0 }}>{content}</h5>)
        }
    }

    const playerName = props.player!.Name ? props.player!.Name : "Player " + props.player!.Number;
    let heroPickedPortraitClass = "picked-hero-container tier-border-";
    if (props.player!.PickedHero) {
        heroPickedPortraitClass += props.player!.PickedHero.Tier;
    }

    let color = props.player.Team.toLowerCase();
    if (meleeContext?.gameData.DraftType === DraftType.FFA) {
        color = PlayerNumberToColor(props.player.Number);
    }

    return (
        <Grid.Column className={"melee-draft-card " + color}>

            <Grid columns={3} style={{ margin: '0 0 -1.5rem' }} relaxed>
                <Grid.Column style={{ width: 'auto' }}>
                    <div className={heroPickedPortraitClass}>
                        <Image src={props.player!.PickedHero ? getHeroImage(meleeContext!.gameData.GameType, props.player!.PickedHero) : UnpickedIcon} size='tiny' />
                    </div>
                </Grid.Column>
                <Grid.Column width={6} style={{ textAlign: 'left', paddingLeft: 0 }}>
                    <h2 style={{ padding: 0, margin: 0 }}>{playerName}</h2>
                    {props.player!.PickedHero &&
                        <h4 style={{ margin: 0 }}>{props.player!.PickedHero.Name}</h4>
                    }
                    {renderTierSection()}

                </Grid.Column>
                {showSelectButton() &&
                    <Grid.Column style={{ margin: 'auto' }}>
                        <Button onClick={() => selectThisPlayer()} basic color={props.player!.Team === Team.Blue ? 'blue' : 'red'}>Velg</Button>
                    </Grid.Column>
                }
                {(meleeContext?.gameData.DraftType === DraftType.Teams || meleeContext?.gameData.DraftType === DraftType.Duel) && allHeroesBanned() &&
                    <Grid.Column style={{ margin: 'auto' }}>
                        <Button onClick={() => randomHeroClick()} basic color={props.player!.Team === Team.Blue ? 'blue' : 'red'}>Random</Button>
                    </Grid.Column>
                }
            </Grid>

            {(meleeContext?.gameData.DraftType === DraftType.Teams || meleeContext?.gameData.DraftType === DraftType.Duel) &&
                <>
                    <Divider></Divider>
                    <Grid columns='equal' relaxed className="hero-images">
                        {renderHeroes()}
                    </Grid>
                </>
            }


        </Grid.Column>
    )
}